import * as genericActions from './general.actions';

export {genericActions};
